module.exports = __webpack_public_path__ + "static/img/4_pyrite_crab.ebfaede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enemies/4_pyrite_crab.png
// module id = hCJ6
// module chunks = 1